import { Injectable } from '@angular/core';
 
@Injectable({
    providedIn: 'root'
})
export class AudioService {
    private audio: any;
    constructor() { }
 
    preloadNotificationRingtone() {
        this.audio = new Audio("assets/media/notification-ringtone.mp3");
        this.audio.autoplay = true;
        this.audio.muted = true;
        this.audio.addEventListener('canplaythrough',function(ev){
            console.log('<b>audio loaded</b>');          
        });
        this.audio.addEventListener('ended',function(ev){
            console.log('<b>audio played</b>');
        });
        this.audio.load();
        this.audio.volume = 1;
    }
 
    playNotificationRingtone() {

        if (this.audio ) {

            this.audio.muted = false;
            this.audio.play().then(() =>
            console.log('Audio played')
            )
                .catch(error => console.log('error:', error));


        }     
    }
 
    stopNotificationRingtone() {
        this.audio.pause();
        this.audio.currentTime = 0;
    }
}
 
